import { useState } from "react";

export function useGovernanceOverride() {
  const [overrideActionId, setOverrideActionId] = useState<"submit-review" | "approve" | null>(
    null,
  );
  const [overrideReason, setOverrideReason] = useState("");
  const [overrideConfirmed, setOverrideConfirmed] = useState(false);
  const [overrideReference, setOverrideReference] = useState<string | null>(null);

  const closeOverride = (): void => {
    setOverrideActionId(null);
    setOverrideReason("");
    setOverrideConfirmed(false);
  };

  return {
    overrideActionId,
    setOverrideActionId,
    overrideReason,
    setOverrideReason,
    overrideConfirmed,
    setOverrideConfirmed,
    overrideReference,
    setOverrideReference,
    closeOverride,
  };
}
